export default __webpack_public_path__ + "static/media/Shendoh of the Whispering Blade.b7812079.jpg";